import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ButtonModel, theme } from '@notino/react-styleguide-v20';

import { useMediaQuery } from '@hooks';
import { generalMessages } from '@services/localizationService';
import { ReactFCV } from '@types';

import { IFooterRowProps } from './model';
import {
  SFooterRow,
  SActionButton,
  SActionButtonWrapper,
  SSmallText,
  SFinalPriceRow,
  SActionComponent,
} from './styled';

export const FooterRow: ReactFCV<IFooterRowProps> = React.memo(
  ({
    firstButtonProps,
    secondButtonProps,
    buttonsSize,
    mobileButtonOrder,
    smallTextUnder,
    priceProps,
    totalPriceText,
    ...rest
  }) => {
    const isDesktopView = useMediaQuery(`(min-width: ${theme.breakpoints.lg}rem)`);
    return (
      <SFooterRow hasTwoButtons={firstButtonProps.isVisible} mobileButtonOrder={mobileButtonOrder} {...rest}>
        {firstButtonProps.isVisible && (
          <SActionButton
            marginTop={firstButtonProps.isVisible}
            data-testid={firstButtonProps.dataTestId ?? 'first-footer-row-btn'}
            buttonStyle={ButtonModel.Styles.secondary}
            buttonSize={buttonsSize}
            onClick={firstButtonProps.onClickAction}
            className={firstButtonProps.className}>
            {firstButtonProps.text}
          </SActionButton>
        )}
        {priceProps && (
          <SFinalPriceRow priceFontSize={isDesktopView ? '1.625rem' : '0.875rem'} {...priceProps}>
            <FormattedMessage {...(totalPriceText ? totalPriceText : generalMessages.totalPrice)} />
          </SFinalPriceRow>
        )}
        {secondButtonProps.isVisible && (
          <SActionButtonWrapper>
            {secondButtonProps.actionComponent ? (
              <SActionComponent>{secondButtonProps.actionComponent}</SActionComponent>
            ) : (
              <SActionButton
                data-testid={secondButtonProps.dataTestId ?? 'second-footer-row-btn'}
                buttonStyle={ButtonModel.Styles.primary}
                buttonSize={buttonsSize}
                onClick={secondButtonProps.onClickAction}
                loading={secondButtonProps.loading}
                error={secondButtonProps.error}
                className={secondButtonProps.className}
                disabled={secondButtonProps.disabled}>
                {secondButtonProps.text}
              </SActionButton>
            )}

            {smallTextUnder && <SSmallText>{smallTextUnder}</SSmallText>}
          </SActionButtonWrapper>
        )}
      </SFooterRow>
    );
  },
);
